import styled from 'styled-components';

import { PULSE, ACQ_MOBILE } from '../../../../theme/tokens';
import { pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** Business Value hero — text top-left, wide gradient chart right (collapses to one
 *  column on mobile). Intentionally the "king of stage" card: ~70% taller than its
 *  natural height (≈168px → 283px, two +30% bumps) so it commands the top of the
 *  Pulse page, with a Lumio-style glow-wave + shooting-star backdrop
 *  (`BusinessValueWaves`) clipped to its rounded rect behind the figure + chart.
 *  Content sits at the TOP of the tall card (`align-items: start`); the chart still
 *  stretches the full height (`align-self: stretch`) so its line rides the middle. */
export const Root = styled.section`
  ${pulseCard}
  position: relative;
  /* Clip the animated waves + stars to the card's rounded rect. (The hover readout
     pins INSIDE the plot for this chart height, so it is never clipped.) */
  overflow: hidden;
  /* Contain the internal stacking (backdrop below, content above) so the z-indexed
     layers never escape to the page. */
  isolation: isolate;
  min-height: 283px;
  padding: 20px;
  display: grid;
  grid-template-columns: 247px 1fr;
  gap: 20px;
  /* Top-align the heading/figure block; the chart overrides with align-self: stretch. */
  align-items: start;

  ${ACQ_MOBILE} {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const TextCol = styled.div`
  position: relative;
  z-index: 1;
  min-width: 0;
`;

export const Title = styled(Text)`
  display: block;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${PULSE.t300};
`;

export const Big = styled.div`
  font-size: 36px;
  font-weight: 800;
  color: ${PULSE.t50};
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-top: 10px;
  font-variant-numeric: tabular-nums;
`;

export const BadgeRow = styled.div`
  margin-top: 10px;
`;

export const Sub = styled(Text)`
  display: block;
  font-size: 12px;
  color: ${PULSE.t500};
  margin-top: 8px;
`;

export const Chart = styled.div`
  position: relative;
  z-index: 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
  align-items: center;

  > div {
    width: 100%;
  }
`;
